import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, Campaign } from "../api";

const policyLabel: Record<string, string> = {
  always_draft: "Always draft",
  auto_safe: "Auto-safe",
  full_auto: "Full auto",
};
const statusColor: Record<string, string> = {
  active: "bg-green-100 text-green-800",
  draft: "bg-ink-100 text-ink-700",
  paused: "bg-amber-100 text-amber-800",
  done: "bg-ink-100 text-ink-500",
};

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState<Campaign[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<{ campaigns: Campaign[] }>("/api/campaigns")
      .then((r) => setCampaigns(r.campaigns))
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Campaigns</h1>
        <Link to="/campaigns/new" className="btn-primary">
          + New campaign
        </Link>
      </div>
      {err && <div className="card border-red-200 bg-red-50 p-4 text-sm text-red-700 mb-4">{err}</div>}
      {!campaigns ? (
        <div className="text-sm text-ink-500">loading…</div>
      ) : campaigns.length === 0 ? (
        <div className="card p-10 text-center">
          <p className="text-ink-500 text-sm">No campaigns yet.</p>
          <Link to="/campaigns/new" className="btn-primary mt-4 inline-flex">
            Create your first campaign
          </Link>
        </div>
      ) : (
        <div className="card divide-y divide-ink-200">
          {campaigns.map((c) => (
            <Link
              key={c.id}
              to={`/campaigns/${c.id}`}
              className="flex items-center justify-between px-4 py-3 hover:bg-ink-50 transition-colors"
            >
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-medium truncate">{c.name}</span>
                  <span className={`pill ${statusColor[c.status] ?? "bg-ink-100"}`}>{c.status}</span>
                  {c.shadow_mode === 1 && <span className="pill bg-blue-100 text-blue-800">shadow</span>}
                </div>
                <div className="text-xs text-ink-500 mt-0.5 font-mono truncate">{c.id}</div>
              </div>
              <div className="text-xs text-ink-500 whitespace-nowrap">{policyLabel[c.reply_policy]}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
